import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getBookingConfig } from "@/lib/bookingConfig";
import RmsRedirect from "@/components/RmsRedirect";
import { useState } from "react";

/**
 * /book — Until RMS Cloud is enabled, we route every booking attempt into the
 * enquiry form (carrying any selected stay type and dates as query params).
 * Once RMS_ENABLED=true, this page deep-links straight to the hosted booking engine.
 */
export default function BookPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getBookingConfig().then((cfg) => {
      if (cancelled) return;
      const m = cfg.booking_mode || "enquiry";
      setMode(m);
      if (m !== "rms") {
        const q = new URLSearchParams();
        const stay = params.get("package") || params.get("stay");
        if (stay) q.set("stay", stay);
        const ci = params.get("check_in") || params.get("arrival");
        if (ci) q.set("check_in", ci);
        const co = params.get("check_out") || params.get("departure");
        if (co) q.set("check_out", co);
        const adults = params.get("adults");
        if (adults) q.set("adults", adults);
        const childrenP = params.get("children");
        if (childrenP) q.set("children", childrenP);
        navigate(`/contact?${q.toString()}`, { replace: true });
      }
    });
    return () => { cancelled = true; };
  }, []);

  if (mode === "rms") {
    return (
      <RmsRedirect
        initial={{
          package_id: params.get("package"),
          arrival: params.get("check_in") || params.get("arrival"),
          departure: params.get("check_out") || params.get("departure"),
          adults: params.get("guests") || params.get("adults"),
          children: params.get("children"),
        }}
      />
    );
  }

  return (
    <section className="max-w-3xl mx-auto px-6 md:px-10 pt-24 pb-32 text-center" data-testid="book-redirect">
      <div className="overline">One moment</div>
      <h1 className="font-serif text-4xl mt-4">Sending you to the enquiry form…</h1>
      <p className="mt-4 text-sa-ink2">Until our online booking engine goes live, we handle bookings personally through enquiry.</p>
    </section>
  );
}
